import ChangeLog from "./components/ChangeLog"

let module = "changelog"

export default [
  {
    path: "changelog",
    component: ChangeLog,
    meta: { module: module, permissions: ["all"] }
  },
]
